import { useEffect, useState } from 'react';
import { Alert, Col, Placeholder, Row } from "react-bootstrap";

import { callLLMInsights } from '../../amplify/api/llm-insights';
import { GET_INSIGHTS_BY_CSN, Insight, callQuery } from '../../amplify/appsync/query';
import { PatientVisit } from '../../amplify/appsync/search-patients';

export interface InsightProps {
    patientVisit: PatientVisit;
}

let isRunningInsight = false;

export const Insights = (props: InsightProps) => {

    const [insightsLoading, setInsightsLoading] = useState<boolean>(false);
    const [insights, setInsights] = useState<Insight[]>([]);

    const fetchInsights = (currPatientVisit: PatientVisit) => {
        setInsights([]);
        setInsightsLoading(true);

        // callLLMInsights(currPatientVisit.csn).then((output: any) => {
        //     console.log("INSIGHTS", output);
        //     setInsightsLoading(false);
        //     const insights = JSON.parse(output["output"]);
        //     setInsights(insights);
        // }).finally(() => {
        //     isRunningInsight = false;
        // });

        callQuery({
            operation: GET_INSIGHTS_BY_CSN,
            csn: currPatientVisit.csn,
        })
        .then((insights: Insight[]) => {
            setInsights(insights);
        }).finally(() => {
            isRunningInsight = false;
            setInsightsLoading(false);
        });
    };

    useEffect(() => {
        if (isRunningInsight) {
            return;
        }
        isRunningInsight = true;
        fetchInsights(props.patientVisit);
    }, [props.patientVisit]);

    return (
        <>
            {
                insightsLoading && (
                    <Placeholder as="p" animation="glow">
                        <Placeholder xs={12} />
                        <Placeholder xs={12} />
                        <Placeholder xs={12} />
                    </Placeholder>
                )
            }
            {
                insights.length > 0 && (
                    <Row xs={1} md={1} className="g-2 mb-2">
                        <Col style={{fontSize: '0.8rem'}}>
                            {
                                insights.map((insight) => (
                                    <Alert variant={insight.severity === "HIGH" ? "danger" : "info"} onClose={() => {}} dismissible={false}>
                                        <div>
                                            <strong>{insight.title}</strong>
                                        </div>
                                        <div>
                                            {insight.description}
                                        </div>
                                    </Alert>
                                ))
                            }
                        </Col>
                    </Row>
                )
            }
        </>
    );
};
